import {
  projectSymbol,
  documentSymbol,
  nodeSymbol,
  nodeChildrenSymbol,
  designerSymbol,
  skeletonSymbol,
  editorSymbol,
  settingPropEntrySymbol,
  settingTopEntrySymbol,
  designerCabinSymbol,
  propSymbol,
  simulatorHostSymbol,
} from '@alilc/lowcode-shell';

export default {
  projectSymbol,
  documentSymbol,
  nodeSymbol,
  nodeChildrenSymbol,
  skeletonSymbol,
  editorSymbol,
  designerSymbol,
  settingPropEntrySymbol,
  settingTopEntrySymbol,
  designerCabinSymbol,
  propSymbol,
  simulatorHostSymbol,
};
